const DBC1_DOMAIN = "dbc1.com";

const getHostname = (): string => {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return "";
  }
  return window.location.hostname.toLowerCase();
};

export const isDbc1Brand = (): boolean => {
  const hostname = getHostname();
  return hostname === DBC1_DOMAIN || hostname.endsWith(`.${DBC1_DOMAIN}`);
};

export const getBrandLogoPath = (variant: "black" | "white"): string =>
  `/assets/img/dbc1-${variant}.svg`;

export const getBrandLogoFolder = (): string => "assets/dbc1";
